import React, { useEffect } from "react";

import { datadogRum } from "@datadog/browser-rum";

function WithRenderTracking(WrappedComponent, componentName = null) {
  const WithTracking = (props) => {
    useEffect(() => {
      datadogRum.addAction(
        `Component ${componentName || WrappedComponent.name} is rendered`
      );
    }, []);

    return <WrappedComponent {...props} />;
  };

  return WithTracking;
}

export default WithRenderTracking;
